'use client';

import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const platformColors: Record<string, string> = {
  LI: '#0A66C2',
  IG: '#C13584',
  X: '#aaa',
  FB: '#1877F2',
};

const calendarData = [
  { id: 'cal-d1', day: 'Mo', date: '06.04', posts: [{ p: 'LI', t: 'Experten-Artikel: KI im Mittelstand' }, { p: 'IG', t: 'Reel-Script: Hinter den Kulissen' }] },
  { id: 'cal-d2', day: 'Di', date: '07.04', posts: [{ p: 'X', t: 'Thread: 5 Fehler bei der Content-Planung' }] },
  { id: 'cal-d3', day: 'Mi', date: '08.04', posts: [{ p: 'LI', t: 'Story: Wie wir in 3 Jahren gewachsen sind' }, { p: 'FB', t: 'Satire: Das tägliche Meeting-Bingo' }] },
  { id: 'cal-d4', day: 'Do', date: '09.04', posts: [{ p: 'IG', t: 'Caption: Produktneuheit Q2' }, { p: 'X', t: 'Meinung: Remote-Work Realität 2026' }] },
  { id: 'cal-d5', day: 'Fr', date: '10.04', posts: [{ p: 'LI', t: 'Case Study: Kunde Müller & Söhne' }] },
  { id: 'cal-d6', day: 'Sa', date: '11.04', posts: [] },
  { id: 'cal-d7', day: 'So', date: '12.04', posts: [{ p: 'IG', t: 'Motivations-Post: Wochenrückblick' }] },
  { id: 'cal-d8', day: 'Mo', date: '13.04', posts: [{ p: 'LI', t: 'Thought Leadership: Zukunft der Arbeit' }, { p: 'FB', t: 'Satire: Die Digitalisierung und ich' }] },
  { id: 'cal-d9', day: 'Di', date: '14.04', posts: [{ p: 'X', t: 'Thread: Warum Standard-Content scheitert' }] },
  { id: 'cal-d10', day: 'Mi', date: '15.04', posts: [{ p: 'LI', t: 'Interview-Format: Mit dem Team' }, { p: 'IG', t: 'Reel: Produktionsprozess Einblick' }] },
  { id: 'cal-d11', day: 'Do', date: '16.04', posts: [{ p: 'X', t: 'Frage an die Community' }, { p: 'FB', t: 'Veranstaltungshinweis: Messe Hannover' }] },
  { id: 'cal-d12', day: 'Fr', date: '17.04', posts: [{ p: 'LI', t: 'Persönliche Geschichte: Gründungsmoment' }] },
  { id: 'cal-d13', day: 'Sa', date: '18.04', posts: [] },
  { id: 'cal-d14', day: 'So', date: '19.04', posts: [{ p: 'IG', t: 'Zitat-Post: Inspirierende Woche' }] },
];

export default function DashboardCalendarStrip() {
  const [hoveredDay, setHoveredDay] = useState<string | null>(null);

  return (
    <div className="punk-card p-5">
      <div className="flex items-center justify-between mb-4">
        <div>
          <p className="section-label">14-Tage Kalender</p>
          <h3 className="text-sm font-600 text-white mt-1">06.04 – 19.04.2026 · Q2-Kampagne</h3>
        </div>
        <div className="flex gap-2">
          <button className="btn-ghost py-1.5 px-3 text-xs"><ChevronLeft size={13} /></button>
          <button className="btn-ghost py-1.5 px-3 text-xs"><ChevronRight size={13} /></button>
        </div>
      </div>
      <div className="grid grid-cols-7 xl:grid-cols-14 2xl:grid-cols-14 gap-2 overflow-x-auto">
        {calendarData.map((day) => (
          <div
            key={day.id}
            className={`min-w-[80px] xl:min-w-0 punk-card p-2.5 cursor-pointer transition-all duration-150 ${
              hoveredDay === day.id ? 'border-accent/50 bg-accent/5' : ''
            } ${day.posts.length === 0 ? 'opacity-40' : ''}`}
            onMouseEnter={() => setHoveredDay(day.id)}
            onMouseLeave={() => setHoveredDay(null)}
          >
            <div className="flex items-center justify-between mb-2">
              <span className="text-xs font-600 text-muted">{day.day}</span>
              <span className="mono text-xs text-muted">{day.date.slice(0, 5)}</span>
            </div>
            <div className="space-y-1">
              {day.posts.length === 0 && (
                <div className="h-4 flex items-center">
                  <span className="text-xs text-muted-2">—</span>
                </div>
              )}
              {day.posts.map((post, idx) => (
                <div
                  key={`${day.id}-post-${idx}`}
                  className="flex items-center gap-1"
                >
                  <span
                    className="text-xs font-700 mono flex-shrink-0"
                    style={{ color: platformColors[post.p] ?? '#666' }}
                  >
                    {post.p}
                  </span>
                  <span className="text-xs text-muted truncate" title={post.t}>
                    {post.t.slice(0, 12)}…
                  </span>
                </div>
              ))}
            </div>
            {day.posts.length > 0 && (
              <div className="mt-2 flex gap-0.5">
                {day.posts.map((post, idx) => (
                  <span
                    key={`${day.id}-dot-${idx}`}
                    className="w-1.5 h-1.5 rounded-full flex-shrink-0"
                    style={{ background: platformColors[post.p] ?? '#666' }}
                  />
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}